import MinusIcon from '@/assets/icons/minus.svg';
import MaxIcon from '@/assets/icons/browser-maximize.svg';
import XIcon from '@/assets/icons/x.svg';
import { de } from 'date-fns/locale';

type Props = {
  title: string;
  description?: string;
  minimize?: boolean;
  onMinimized?: () => void;
  onClose: () => void;
  isActive?: boolean;
};

function HeaderModal({ title, description, onMinimized, onClose, minimize, isActive }: Props) {
  return (
    <div className="sticky " style={{ zIndex: 999 }}>
      <div className="flex p-3 pm-6 shadow bg-white justify-between items-center rounded-t-lg dark:bg-gray-800">
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-base font-medium dark:text-white">{title}</h1>
            {isActive && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800 shadow-xs">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                Active
              </span>
            )}
          </div>
          {description && (
            <span className="text-sm text-gray-500 dark:text-gray-400">{description}</span>
          )}
        </div>
        <div className="flex">
          {onMinimized && (
            <button
              type="button"
              className="text-black-400 mr-3 dark:text-white"
              onClick={() => onMinimized()}
            >
              {!minimize ? <MinusIcon className="h-5 w-5" /> : <MaxIcon className="h-5 w-5" />}
            </button>
          )}
          {onClose && (
            <button
              type="button"
              className="text-black-400 dark:text-white"
              onClick={() => onClose()}
            >
              <XIcon className="h-5 w-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default HeaderModal;
